import {language as en} from './en/text';
import {language as de} from './de/text';


export const language = {en, de}